import React from 'react';
import styles from '../styles/page.module.scss';
import { Text } from '@clockout-dev/design-elements';

/**
 * Page heading with optional highlighted span and description.
 *
 * @param {Object} props
 * @param {{ text?: string, highlight?: string }} [props.title]
 * @param {string} [props.description]
 * @param {JSX.Element} [action] - Optional right-aligned page action
 * @returns {JSX.Element}
 */
function PageTitle({ title, description, action }) {
    const fullTitle = [title?.text, title?.highlight].filter(Boolean).join(' ');

    return (
        <div className={styles.pageTitle}>
            <div className={styles.pageTitleContent}>
                <Text size="display-xl" as="h1" className={styles.title} title={fullTitle || undefined}>
                    {title?.text}
                    {title?.highlight ? (
                        <Text size="display-xl" as="span" className={styles.titleHighlight}>
                            {' ' + title.highlight}
                        </Text>
                    ) : null}
                </Text>
                {description ? (
                    <Text as="p" size="l" className={styles.description}>
                        {description}
                    </Text>
                ) : null}
            </div>
            {action ? <div className={styles.pageTitleAction}>{action}</div> : null}
        </div>
    );
}

export default PageTitle;
